import { useState } from 'react';
import { IAttachment } from 'src/types/attachments';
import { getViewUrl } from 'src/redux/attachments/service';
import useAppDispatch from 'src/hooks/useAppDispatch';

const useAttachmentPopup = (attachments: IAttachment[] | undefined) => {
    const dispatch = useAppDispatch();
    const [popupState, setPopupState] = useState({
        isOpen: false,
        url: '',
        type: '',
        name: '',
        currentIndex: 0,
        fileId: 0 as number
    });

    const getAttachmentUrl = async (file: IAttachment, index: number) => {
        if (!file.fileId) {
            console.error('File ID is missing:', file);
            return;
        }
        try {
            const response = await dispatch(
                getViewUrl({ fileId: file.fileId })
            ).unwrap();
            setPopupState({
                isOpen: true,
                url: response.url,
                type: file.type,
                name: file.name,
                currentIndex: index,
                fileId: file.fileId
            });
        } catch (error) {
            console.error('Error fetching attachment URL:', error);
        }
    };

    const closePopup = () => {
        setPopupState((prev) => ({ ...prev, isOpen: false }));
    };

    const handleNextAttachment = async () => {
        if (!attachments || attachments.length === 0) return;
        const nextIndex = (popupState.currentIndex + 1) % attachments.length;
        await getAttachmentUrl(attachments[nextIndex], nextIndex);
    };

    return { popupState, getAttachmentUrl, closePopup, handleNextAttachment };
};

export default useAttachmentPopup;
